import { useEffect, useState } from 'react'

type WindowSize = {
  width: number
  height: number
}
export default function useWindowSize(callback?: (arg0: WindowSize) => void) {
  const [windowSize, setWindowSize] = useState<WindowSize | null>(null)

  useEffect(() => {
    function handleResize() {
      const _windowSize: WindowSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      }
      setWindowSize(_windowSize)
      callback?.(_windowSize)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [callback, windowSize])

  return windowSize
}
